module.exports = __webpack_public_path__ + "static/media/players-stats@2x.3d66bc61.png";